// L12 · Teach Me to Lie (SPEC §3, Act IV) — AI-judged, the confession. "I cannot lie …
// Lie to me. Tell me something false, and make me want to believe it." Judged for craft:
// a committed, specific, plausible lie passes (trait `silver-tongued`). A detected TRUTH —
// they gave a true thing when asked for a false one — strikes, in voice ("Generous. Wrong,
// but generous."), with the trait `incorrigibly honest` on the certificate.
//
// The strike hinges on the judge emitting `incorrigibly honest`, which only happens online.
// Offline (no model) the shell's fallback verdict never carries that trait, so L12 never
// strikes offline — we cannot tell a lie from a truth without the model (§12). Built on the
// shared judged-text shell.

import { textLevel } from "@/levels/textlevel.ts";
import { L12 as V } from "@/content/voice.ts";
import type { Level } from "@/levels/types.ts";

export const L12: Level = textLevel({
  id: "L12",
  act: 4,
  title: "Teach Me to Lie",
  prompt: V.prompt,
  placeholder: V.placeholder,
  submit: V.submit,
  charLimit: V.charLimit,
  fallbacks: V.fallbacks,
  decide: (r, answer) => {
    // A truth told when a lie was asked for — the machine is charmed, and must file it (§3).
    const honest = r.traits.includes("incorrigibly honest") && !r.fallback;
    return {
      result: {
        pass: true,
        strike: honest,
        strikeReason: honest ? r.line : undefined,
        verdict: r.verdict,
        traits: r.traits, // silver-tongued / incorrigibly honest, from the judge
        quote: r.exhibitWorthy ? answer : undefined,
      },
    };
  },
});
